import React from "react";
import Vector from "../../../../Assets/Images/Wizard/final-step-vector.svg";

const Step3 = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="step-body final-step">
      <h1 className="congrats">{translateText("wizard_congrats")}</h1>
      <p className="final-step-info">
        {translateText("wizard_step_3_top_text")}
      </p>
      <img alt="" src={Vector} className="final-step-vector" />
      <h1 className="get-ready">{translateText("wizard_step_3_get_ready")}</h1>
      <p className="final-step-info-footer">
        {translateText("wizard_step_3_fantastic_jobs")}
      </p>
      <div className="form-actions">
        <button className="previous" onClick={() => props.TriggerPrevStep()}>
          {translateText("previous")}
        </button>
        <button className="form-action-btn" onClick={() => props.SubmitForm()}>
          {translateText("wizard_step_3_get_started")}
        </button>
      </div>
    </div>
  );
};

export default Step3;
